import * as React from 'react';
import { jsx, css } from '@emotion/react';
import type { answerWithImageType } from '../../views/types';
import type { SectionsPropsType } from '../types';
import { renderAdvisorMessage } from '../../views/AdvisorMessage';
import { renderUserMessage } from '../../views/UserMessage';
import { renderRadioLikeButtonGroupWithImage } from '../../views/RadioLikeButtonGroupWithImage';
import { buildAnswers, buildUserAnswerMessage } from '../utils';

import RoofingMaterialKawaraPngPath from 'Images/me/pages/guest/proposals/new/roofing_material/kawara.png'
import RoofingMaterialKawaraWebPPath from 'Images/me/pages/guest/proposals/new/roofing_material/kawara.webp'
import RoofingMaterialSlatePngPath from 'Images/me/pages/guest/proposals/new/roofing_material/slate.png'
import RoofingMaterialSlateWebPPath from 'Images/me/pages/guest/proposals/new/roofing_material/slate.webp'
import RoofingMaterialGalvalumePngPath from 'Images/me/pages/guest/proposals/new/roofing_material/galvalume.png'
import RoofingMaterialGalvalumeWebPPath from 'Images/me/pages/guest/proposals/new/roofing_material/galvalume.webp'
import RoofingMaterialGalvanisedIronPngPath from 'Images/me/pages/guest/proposals/new/roofing_material/galvanised_iron.png'
import RoofingMaterialGalvanisedIronWebPPath from 'Images/me/pages/guest/proposals/new/roofing_material/galvanised_iron.webp'

const SECTION_KEY_NAME = 'roofingMaterial';
const PARAM_NAME = SECTION_KEY_NAME;
const GA_EVENT_NAME = 'roofingMaterial';

export const roofingMaterialSection = async (props: SectionsPropsType) => {
  const { userAnswers, commonAnswerHandler } = props;
  const answers: answerWithImageType[] = [
    {
      value: '瓦',
      imagePaths: {
        imagePath: RoofingMaterialKawaraPngPath,
        webp: RoofingMaterialKawaraWebPPath,
      }
    },
    {
      value: 'スレート',
      imagePaths: {
        imagePath: RoofingMaterialSlatePngPath,
        webp: RoofingMaterialSlateWebPPath,
      }
    },
    {
      value: 'ガルバリウム',
      imagePaths: {
        imagePath: RoofingMaterialGalvalumePngPath,
        webp: RoofingMaterialGalvalumeWebPPath,
      }
    },
    {
      value: 'トタン',
      imagePaths: {
        imagePath: RoofingMaterialGalvanisedIronPngPath,
        webp: RoofingMaterialGalvanisedIronWebPPath,
      }
    },
    {
      value: 'その他',
      imagePaths: null
    },
    {
      value: 'わからない',
      imagePaths: null
    },
  ];
  const answerHandler = (event: React.MouseEvent<HTMLButtonElement>): void => {
    const { textContent, value } = event.currentTarget;

    commonAnswerHandler(PARAM_NAME, textContent || '');

    userAnswers.push({
      keyName: SECTION_KEY_NAME,
      paramName: PARAM_NAME,
      question: '今の屋根材は',
      answer: textContent || '',
      value: value || '',
    });
  };

  // アドバイザーの吹き出し
  await renderAdvisorMessage({
    ...props,
    keyName: SECTION_KEY_NAME,
    messageElement: (
      <>
        現在の屋根材はどのようなものをお使いですか？
      </>
    ),
  });

  // 回答ボタン表示
  const answer = await renderRadioLikeButtonGroupWithImage({
    ...props,
    keyName: SECTION_KEY_NAME,
    answers: buildAnswers({
      keyName: SECTION_KEY_NAME,
      answers,
      answerHandler,
      gaEventName: GA_EVENT_NAME,
    }),
  });

  // ユーザーの吹き出し
  await renderUserMessage({
    ...props,
    keyName: SECTION_KEY_NAME,
    messageElement: buildUserAnswerMessage(answer.answerText),
  });

  // 回答内容を返却する
  return answer;
};
